module.exports = __webpack_public_path__ + "media/img/corporate/cover-7d987b0568870efcc53bccc35ffb2070.png";